<template>

    <b-modal size="lg" id="tracking" title="BootstrapVue" @shown="filterItems()" @ok="handleOk">
        <template #modal-title>
            <h6 class="m-0 fw-bold text-green text-sm">
                Transaction Imbalance Tracker
            </h6>
        </template>
        <div class="row mb-2">
            <div class="col-12 col-md-4 mb-2">
                <label class="akkurate-dark small" for="date">From Date</label>
                <b-form-group label-for="start_date" class="akkurate-dark">
                    <b-form-input id="start_date" class="mt-1 field-container fields" type="date"
                        v-model="form.start_date">
                    </b-form-input>
                </b-form-group>
            </div>

            <div class="col-12 col-md-4 mb-2">
                <label class="akkurate-dark small" for="date">To Date</label>
                <b-form-group label-for="end_date" class="akkurate-dark">
                    <b-form-input id="end_date" class="mt-1 field-container fields" type="date" v-model="form.end_date">
                    </b-form-input>
                </b-form-group>
            </div>
            <div class="col-12 col-md-4 mb-2">
                <label class="akkurate-dark small" for="branch">Branch</label>
                <multiselect class="mt-1 field-container" v-model="form.branch" :options="branch_option" track-by="name"
                    placeholder="Select one" selectLabel="" deselectLabel="" label="name" :preselect-first="true">
                </multiselect>
            </div>
        </div>
        <div class="card card-shape home-box">
            <div class="card-header">
                <div class="d-flex justify-content-between align-items-center">
                    <h6 class="m-0 fw-bold text-green">
                        Transaction List
                    </h6>
                    <b-link @click="exportToExcel" class="fw-semibold ms-2 akkurate-green">
                        <font-awesome-icon :icon="['fas', 'file-excel']" /></b-link>
                </div>
            </div>
            <div class="card-body default_bg" style="border-bottom: 1px solid rgb(1, 134, 115)">
                <div class="home-box border border-success py-1 bg-white">
                    <div class="my-1 row text-center">
                        <div class="col">
                            <p class="mb-0 small">
                                <font-awesome-icon :icon="['fas', 'circle']" class="akkurate-green" />
                                Total Credit <br /><span class="fw-bold">{{
                                    displayNumber(total_credit)
                                    }}</span>
                            </p>
                        </div>
                        <div class="col">
                            <p class="mb-0 small">
                                <font-awesome-icon :icon="['fas', 'circle']" class="akkurate-danger" />
                                Total Debit <br /><span class="fw-bold">{{
                                    displayNumber(total_debit)
                                    }}</span>
                            </p>
                        </div>
                        <div class="col">
                            <p class="mb-0 small">
                                <font-awesome-icon :icon="['fas', 'circle']" class="akkurate-grey rounded-circle" />
                                Total Difference <br /><span class="fw-bold">{{
                                    displayNumber(total_difference)
                                    }}</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>


            <div class="card-body p-0 table_text_size">
                <b-table striped bordered responsive id="allCOATransactionTable" :busy.sync="isLoading" :items="items"
                    :fields="fields" :tbody-tr-class="rowClass" show-empty>
                    <template #empty="scope">
                        <h4 class="text-center small mt-3">
                            {{ scope.emptyText }}
                        </h4>
                    </template>
                    <template #table-busy>
                        <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Loading...</strong>
                        </div>
                    </template>
                    <template #cell(index)="data">
                        {{ data.index + 1 }}
                    </template>
                    <template #cell(actions)="data">
                        <a title="Add" class="btn btn-sm text-white akkurate-green-btn border-0 custom-pointer"
                            @click="getImbalanceTransaction(data.item.reference)">
                            <span class="akkurate-small"><font-awesome-icon :icon="['fas', 'forward']" /></span>
                        </a>
                    </template>
                </b-table>
                <div class="d-flex justify-content-between px-1">
                    <b-pagination class="mt-1" @change="navigatePage" v-model="currentPage" :total-rows="totalRecords"
                        :per-page="perPage" aria-controls="member-table"></b-pagination>
                    <div class="col text-end mt-1 akkurate-dark">
                        <div>
                            {{ currentPage }} - {{ perPage }} of
                            {{ totalRecords }}
                        </div>
                        <b-form-group label="Per Page" label-size="sm" class="mb-0">
                            <b-form-select @change="selectPerPage" id="per-page-select" v-model="perPage"
                                :options="per_page_options" size="sm"></b-form-select>
                        </b-form-group>
                    </div>
                </div>
            </div>

        </div>

        <template #modal-footer="{ ok }">
            <div class="w-100">
                <!-- Emulate built in modal footer ok and cancel button actions -->
                <b-button @click="$bvModal.hide('tracking')" type="button"
                    class="akkurate-grey-btn border-0 btn-size ms-2 float-right"><span class="small"><font-awesome-icon
                            class="me-2" :icon="['fas', 'close']" />Cancel
                    </span></b-button>
                <b-button @click="ok()" type="submit" :disabled="isSaving"
                    class="akkurate-green-btn btn-size float-right border-0"><span class="small"><font-awesome-icon
                            class="me-2" :icon="['fas', 'magnifying-glass']" />Find</span></b-button>
            </div>
        </template>
    </b-modal>
</template>

<script>
import Multiselect from "vue-multiselect";
import ApiService from "@/core/services/api.service";
export default {
    components: {
        Multiselect
    },
    props: ['branch_option','institution'],
    data() {
        return {
            form: {
                start_date: this.getBeginningOfYear(),
                end_date: new Date().toISOString().split("T")[0],
                branch: [],
            },
            isSaving: false,
            isLoading: false,
            items: [],
            currentPage: 1,
            perPage: 10,
            per_page_options: ["10", "20", "50", "100", "200","300","500"],
            totalRecords: 0,
            total_credit: 0,
            total_debit: 0,
            total_difference: 0,
            fields: [
                {
                    label: "References",
                    key: "reference",
                },
                {
                    label: "Credit",
                    key: "cr_amount",
                },
                {
                    label: "Debit",
                    key: "dr_amount",
                },
                {
                    label: "Difference",
                    key: "differences",
                },
                {
                    label: "Transaction Date",
                    key: "transaction_date",
                },
                {
                    label: "Actions",
                    key: "actions",
                },
            ]
        }
    },
    methods: {
        async loadItems() {
            this.isLoading = true;
            await ApiService.post("/finance/coa-transactions/unbalanced-transactions", {
                page: this.currentPage,
                per_page: this.perPage,
                branch: this.form.branch?.id,
                start_date: this.form.start_date,
                end_date: this.form.end_date
            })
                .then((response) => {
                    this.items = response.data.data;
                    this.totalRecords = response.data.pagination.total;
                    console.log(response);
                    this.$Progress.finish();
                    this.total_credit = response.data.totals.total_credit
                    this.total_debit = response.data.totals.total_debit
                    this.total_difference = response.data.totals.total_difference
                })
                .catch((error) => {
                    this.isLoading = false;
                    this.$Progress.fail();
                })
                .finally(() => {
                    this.isLoading = false;
                    this.$Progress.finish();
                });
        },
        handleOk(bvModalEvent) {
            // Prevent modal from closing
            bvModalEvent.preventDefault();
            this.filterItems();
        },
        filterItems() {
            console.log("Here");
            this.loadItems();
        },
        rowClass() {
            return "custom-row-height";
        },
        navigatePage(index) {
            this.isLoading = true;
            this.currentPage = index;
            this.loadItems();
        },
        selectPerPage(index) {
            this.perPage = index;
            this.loadItems();
        },
        getImbalanceTransaction(reference) {
            this.$bvModal.hide('tracking')
            this.$emit('getImbalance', reference);
        },
        // Add this method to your methods section
        async exportToExcel() {
            const fileUrl = "/REPORT_TEMPLATE_NEW.xlsx"; // Path to the file in the public folder
            const imageUrl = "/default_logo.png"; // Path to your image file

            // Institution details (you'll need to pass this as a prop or fetch it)
            const institutionName = this.institution?.name || "Institution Name";
            const institutionMotto = this.institution?.motto || "";
            const institutionAddress = this.institution?.address || "";
            const institutionPhone = this.institution?.telephone || "";
            const institutionEmail = this.institution?.email || "";

            try {
                // Fetch the Excel file from the public URL
                const response = await fetch(fileUrl);
                if (!response.ok) {
                    throw new Error(
                        `Network response was not ok: ${response.statusText}`
                    );
                }
                const arrayBuffer = await response.arrayBuffer();

                // Load the file into ExcelJS
                const ExcelJS = require('exceljs');
                const wb = new ExcelJS.Workbook();
                await wb.xlsx.load(arrayBuffer);

                // Access the first sheet
                const ws = wb.getWorksheet(1); // Get the first worksheet

                // Add Image to the top of the sheet
                const imageResponse = await fetch(imageUrl);
                const imageBuffer = await imageResponse.arrayBuffer();
                const imageId = wb.addImage({
                    buffer: imageBuffer,
                    extension: "png", // Adjust this if you're using a different image type (e.g., jpg)
                });

                // Insert the image at the top-left corner (row 1, column 1)
                ws.addImage(imageId, {
                    tl: { col: 0, row: 0 }, // Top-left corner (adjust this as needed)
                    ext: { width: 300, height: 200 }, // Set the image size (adjust width/height as needed)
                });

                // Insert institution details next to the image (starting at row 1, col 5)
                const institutionDetailsStartCol = 5; // Column where text starts after image
                const institutionDetailsRow = 1; // Row for institution details

                // Add the institution name, address, and phone number
                ws.getCell(`M${institutionDetailsRow}`).value = institutionName;
                ws.getCell(`M${institutionDetailsRow}`).font = {
                    bold: true,
                    size: 14,
                }; // Bold and bigger font for name

                ws.getCell(`M${institutionDetailsRow + 1}`).value = institutionAddress;
                ws.getCell(`M${institutionDetailsRow + 1}`).font = {
                    size: 12,
                }; // Regular font size for address

                ws.getCell(`M${institutionDetailsRow + 2}`).value = institutionMotto;
                ws.getCell(`M${institutionDetailsRow + 2}`).font = {
                    size: 12,
                }; // Regular font size for motto

                ws.getCell(`M${institutionDetailsRow + 3}`).value = institutionPhone;
                ws.getCell(`M${institutionDetailsRow + 3}`).font = {
                    size: 12,
                }; // Regular font size for phone

                ws.getCell(`M${institutionDetailsRow + 4}`).value = institutionEmail;
                ws.getCell(`M${institutionDetailsRow + 4}`).font = {
                    size: 12,
                }; // Regular font size for email

                // Add report title
                ws.getCell(`M${institutionDetailsRow + 6}`).value = "TRANSACTION IMBALANCE REPORT";
                ws.getCell(`M${institutionDetailsRow + 6}`).font = {
                    bold: true,
                    size: 16,
                };

                // Add filter information
                let filterInfo = `Period: ${this.form.start_date || 'N/A'} to ${this.form.end_date || 'N/A'}`;
                if (this.form.branch?.name) {
                    filterInfo += ` | Branch: ${this.form.branch.name}`;
                }
                ws.getCell(`M${institutionDetailsRow + 7}`).value = filterInfo;
                ws.getCell(`M${institutionDetailsRow + 7}`).font = {
                    size: 12,
                };

                // Add summary information
                ws.getCell(`M${institutionDetailsRow + 8}`).value = `Total Credit: ${this.displayNumber(this.total_credit)}`;
                ws.getCell(`M${institutionDetailsRow + 8}`).font = {
                    bold: true,
                    size: 12,
                };

                ws.getCell(`M${institutionDetailsRow + 9}`).value = `Total Debit: ${this.displayNumber(this.total_debit)}`;
                ws.getCell(`M${institutionDetailsRow + 9}`).font = {
                    bold: true,
                    size: 12,
                };

                ws.getCell(`M${institutionDetailsRow + 10}`).value = `Total Difference: ${this.displayNumber(this.total_difference)}`;
                ws.getCell(`M${institutionDetailsRow + 10}`).font = {
                    bold: true,
                    size: 12,
                };

                // Optionally adjust the column width if the text is long
                ws.getColumn("N").width = 50; // Adjust the width of column N (if necessary)

                // Define header row
                const header = [
                    "S/N",
                    "Reference",
                    "Credit_Amount",
                    "Debit_Amount",
                    "Difference",
                ];

                // Add header row starting from row 13 (or the next row after the image and details)
                const startingRow = institutionDetailsRow + 12; // Row after institution details and summary
                let headerRow = ws.getRow(startingRow);
                headerRow.values = header;
                headerRow.font = { bold: true };
                headerRow.commit(); // Commit the row to the worksheet

                // Add individual data rows
                let currentRow = startingRow + 1;

                // Process each item
                this.items.forEach((item, index) => {
                    const row = ws.getRow(currentRow);
                    // Map item values to the corresponding header columns
                    row.values = [
                        index + 1, // Serial number
                        item.reference,
                        item.cr_amount,
                        item.dr_amount,
                        item.differences,
                    ];
                    row.commit();
                    currentRow++;
                });

                // Add totals row
                const totalsRow = ws.getRow(currentRow + 1);
                totalsRow.values = [
                    "TOTALS",
                    "",
                    this.total_credit,
                    this.total_debit,
                    this.total_difference,
                ];
                totalsRow.font = { bold: true };
                totalsRow.commit();

                const buffer = await wb.xlsx.writeBuffer();
                const blob = new Blob([buffer], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });

                // Create a download link and simulate a click to download the file
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);

                // Generate filename with timestamp and branch info
                const now = new Date();
                const timestamp = now.toISOString().slice(0, 19).replace(/:/g, '-');
                const branchName = this.form.branch?.name ? `_${this.form.branch.name}` : '';
                link.download = `Transaction_Imbalances${branchName}_${timestamp}.xlsx`;

                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } catch (err) {
                console.error(
                    "Error fetching, modifying, or downloading the Excel file:",
                    err.message
                );
            }
        },

    }

}
</script>